module.exports = __webpack_public_path__ + "img/hokou-ai-5.70407fc8.svg";